import {
  ListeningPackageType,
  PackageThumbnail,
  PriceDetails,
  PromocodeCalculateSummary,
  PromocodeResponse
} from '../../common/services/package/package.model';
import PackageService from '../../common/services/package/package.service';
import PriceService from '../../common/services/price.service';
import UtilService from '../../common/services/util.service';

/* @ngInject */
export default class PacketCardController {
  public packet: PackageThumbnail;
  public priceDetails: PriceDetails;
  public timePeriod: string;
  protected discount: PromocodeResponse;

  protected firstThreePrice: string;
  protected laterPrice: string;
  protected totalPrice: string;
  protected price: string;
  protected firstPrice: string;
  protected firstXMonth: string;
  protected firstXPrice: string;
  protected firstXFree: string;
  protected basePrice: string;

  // Uyeler protected: no-auth karti bu sinifi genisletip yalnizca getInfo ve
  // getIcon metotlarini degistiriyor, promokod gorunumunun tamami paylasiliyor.
  constructor(
    protected packageService: PackageService,
    protected $sce,
    protected $translate,
    protected $rootScope,
    protected priceService: PriceService,
    protected $stateParams,
    protected i18n
  ) {}

  public $onInit() {
    if (!this.packet) {
      return;
    }

    this.loadTranslations();

    this.$rootScope.$on('$translateChangeSuccess', () => {
      this.loadTranslations();
    });
  }

  public loadTranslations() {
    this.getInfo();
    this.$translate('packet.firstThreePrice', this.priceDetails).then(value => {
      this.firstThreePrice = this.$sce.trustAsHtml(value);
    });

    this.$translate('packet.laterPrice', this.priceDetails).then(value => {
      this.laterPrice = this.$sce.trustAsHtml(value);
    });

    this.$translate('packet.totalPrice', this.priceDetails).then(value => {
      this.totalPrice = this.$sce.trustAsHtml(value);
    });

    this.$translate('packet.firstPrice', this.priceDetails).then(value => {
      this.firstPrice = this.$sce.trustAsHtml(value);
    });

    this.$translate('packet.firstXPrice', this.priceDetails).then(value => {
      this.firstXPrice = this.$sce.trustAsHtml(value);
    });

    this.$translate('packet.firstXFree', this.priceDetails).then(value => {
      this.firstXFree = this.$sce.trustAsHtml(value);
    });

    this.$translate('packetCard.firstXMonth', this.priceDetails).then(value => {
      this.firstXMonth = this.$sce.trustAsHtml(value);
    });

    this.$translate('packet.basePrice', this.priceDetails).then(value => {
      this.basePrice = this.$sce.trustAsHtml(value);
    });
  }

  public isPaycellPackage() {
    return this.packet.type === ListeningPackageType.CREDITCARD;
  }

  public getInfo() {
    try {
      this.timePeriod = this.priceService.getPriceInfo(this.packet);

      this.packageService.getOfferablePackage().then(packages => {
        this.packet =
          packages[
            UtilService.getElementIndexById(
              packages,
              this.$stateParams.packetId
            )
          ];
      });

      this.priceDetails = JSON.parse(this.packet.priceDescription);
      this.priceDetails.priceUnit = 'TL';
      this.priceDetails.basePrice = this.packet.basePrice;

      const translation = this.$translate.instant(this.timePeriod);
      this.priceDetails.time = this.$sce.valueOf(translation);
    } catch (error) {
      // priceDescription bozuk JSON olabilir; kart fiyat satirlarisiz cizilir.
    }
  }

  public getIcon() {
    return this.packageService.getPackageIcon(this.packet);
  }

  public getDescription() {
    if (this.priceDetails.descriptionEn === undefined) {
      return this.priceDetails.descriptionTr;
    }

    if (
      this.priceDetails.descriptionTr === undefined ||
      this.i18n.getCurrentLanguage() === 'en'
    ) {
      return this.priceDetails.descriptionEn;
    }

    return this.priceDetails.descriptionTr;
  }

  public getDiscountRate() {
    const rate = this.getCalculatedDiscountRateValue();
    if (!rate) {
      return '';
    }

    if (this.i18n.getCurrentLanguage() === 'en') {
      return rate + '%';
    }

    return '%' + rate;
  }

  public getDiscountPrice() {
    return (
      '<span>' +
      this.discount.discountedPrice +
      ' ' +
      this.priceDetails.priceUnit +
      this.priceDetails.time +
      '</span>'
    );
  }

  public isYearlyPackage() {
    return (
      this.packet &&
      (this.packet.period === 'YEARLY' ||
        this.packet.period === 'CONTRACTEDYEARLY')
    );
  }

  public getPricePeriod() {
    if (this.discount && this.discount.discountedRenewalCount) {
      return this.discount.discountedRenewalCount;
    }

    if (
      this.discount &&
      angular.isNumber(this.discount.promocodeAppliedCount)
    ) {
      return this.discount.promocodeAppliedCount.toString();
    }

    if (!this.packet.period) {
      return '1';
    }

    return this.packet.period === 'YEARLY' ||
    this.packet.period === 'CONTRACTEDYEARLY'
      ? '12'
      : '1';
  }

  public getPromocodeAppliedCount() {
    if (!this.discount) {
      return 0;
    }

    if (angular.isNumber(this.discount.promocodeAppliedCount)) {
      return this.discount.promocodeAppliedCount;
    }

    if (this.discount.discountedRenewalCount) {
      return parseInt(this.discount.discountedRenewalCount, 10);
    }

    return 0;
  }

  // ---------------------------------------------------------------------
  // calculate ozeti (discountedPrices) tabanli kart gorunumu
  // ---------------------------------------------------------------------

  public getCalculateSummary(): PromocodeCalculateSummary {
    return this.discount ? this.discount.calculateSummary : undefined;
  }

  /** Yeni tasarim yalnizca ilk eleman trial === true geldiginde calisir. */
  public hasTrialSummary() {
    const summary = this.getCalculateSummary();

    return !!(summary && summary.startsWithTrial && summary.freeCount > 0);
  }

  /** Bedava aylarin ardindan ucretli bir ay var mi. */
  public hasPaidMonths() {
    const summary = this.getCalculateSummary();

    return !!(
      summary &&
      !summary.allFree &&
      angular.isNumber(summary.standardPrice)
    );
  }

  /**
   * Bedava ay yok, indirim ilk aydan itibaren uygulaniyor.
   * Kartta "Ilk X ay / indirimli fiyat" ve "Standart fiyat / paket fiyati"
   * satirlari cikar. Kod ile indirim satiri gosterilmez; yesil bilgi kutusunda
   * getDiscountFromFirstMonthInfoText() metni yazar.
   */
  public hasDiscountFromFirstMonth() {
    const summary = this.getCalculateSummary();

    return !!(
      summary &&
      summary.freeCount === 0 &&
      angular.isNumber(summary.standardPrice) &&
      angular.isNumber(summary.discountAmount) &&
      angular.isNumber(summary.discountedPrice)
    );
  }

  /**
   * Calculate ozetinden uretilen gorunumlerden biri aktif mi.
   * Aktifse paketin kendi priceDescription satirlari ve legacy indirim blogu gizlenir.
   */
  public hasCalculateLayout() {
    return this.hasTrialSummary() || this.hasDiscountFromFirstMonth();
  }

  /**
   * Tum aylar bedava. Kartta indirim satiri yoktur; yalnizca bedava ay satiri
   * ile paketin kendi standart fiyati gosterilir.
   */
  public hasOnlyFreeMonths() {
    const summary = this.getCalculateSummary();

    return !!(summary && summary.allFree);
  }

  /** Paketin promokodsuz fiyati: "114,99 TL / ay" */
  public getPacketPriceText() {
    const price = this.toNumber(
      this.packet && angular.isDefined(this.packet.price)
        ? this.packet.price
        : this.priceDetails && this.priceDetails.totalPrice
    );

    if (!angular.isNumber(price)) {
      return '';
    }

    return this.formatPriceWithPeriod(price);
  }

  /**
   * Paketin kendi deneme donemi: list/v2 cevabindaki trialPeriodCount.
   * Aylik olmayan deneme donemlerinde sayi ay cinsinden degildir, kullanilmaz.
   */
  private getPacketTrialMonthCount(): number {
    if (
      !this.packet ||
      !angular.isNumber(this.packet.trialPeriodCount) ||
      (this.packet.trialPeriod && this.packet.trialPeriod !== 'MONTHLY')
    ) {
      return 0;
    }

    return this.packet.trialPeriodCount;
  }

  /**
   * Paketin kendi tanimindaki bedava ay sayisi.
   * Promokodsuz kartta "Ilk X ay / ucretsiz" satirini bu deger basar.
   * Oncelik yapilandirilmis trialPeriodCount alanindadir; gonderilmeyen
   * paketlerde priceDescription.firstXMonth metnine dusulur.
   */
  public getPacketFreeMonthCount(): number {
    const trialMonthCount = this.getPacketTrialMonthCount();
    if (trialMonthCount > 0) {
      return trialMonthCount;
    }

    if (!this.priceDetails || !this.priceDetails.firstXFree) {
      return 0;
    }

    const parsed = parseInt(String(this.priceDetails.firstXMonth), 10);

    return isNaN(parsed) ? 0 : parsed;
  }

  /**
   * Kartta yazilacak bedava ay sayisi.
   * Promokod cevabi paketin kendi bedava aylarindan azini bildirirse paketin
   * sayisi kazanir: kod girildiginde kullanici daha az bedava ay gormemeli.
   */
  public getFreeMonthCount(): number {
    const summary = this.getCalculateSummary();

    return Math.max(summary ? summary.freeCount : 0, this.getPacketFreeMonthCount());
  }

  /** "Ilk ay" / "Ilk 2 ay" */
  public getFreeMonthLabel() {
    const summary = this.getCalculateSummary();
    if (!summary) {
      return '';
    }

    const freeMonthCount = this.getFreeMonthCount();
    const label =
      freeMonthCount === 1
        ? this.$translate.instant('packetCard.firstMonth')
        : this.$translate.instant('packetCard.firstXMonth', {
            firstXMonth: freeMonthCount
          });

    return this.$sce.trustAsHtml(label);
  }

  /**
   * Bedava donemi olmayan kampanyada indirimli donemin basligi.
   * Yillik pakette "Ilk X yil", aylik pakette "Ilk X ay" yazilir.
   * Donem sayisi dogrudan discountedPrices dizisinin uzunlugudur.
   */
  public getDiscountedMonthLabel() {
    const summary = this.getCalculateSummary();
    if (!summary) {
      return '';
    }

    const isYearlyPackage = this.isYearlyPackage();
    if (summary.totalCount === 1) {
      return this.$sce.trustAsHtml(
        this.$translate.instant(
          isYearlyPackage ? 'packetCard.firstYear' : 'packetCard.firstMonth'
        )
      );
    }

    const translationKey = isYearlyPackage
      ? 'packetCard.firstXYear'
      : 'packetCard.firstXMonth';
    const translationParams = isYearlyPackage
      ? { firstXYear: summary.totalCount }
      : { firstXMonth: summary.totalCount };
    const label = this.$translate.instant(translationKey, translationParams);

    return this.$sce.trustAsHtml(label);
  }

  public getStandardPriceText() {
    const summary = this.getCalculateSummary();
    if (!summary || !angular.isNumber(summary.standardPrice)) {
      return '';
    }

    return this.formatPriceWithPeriod(summary.standardPrice);
  }

  /** Indirim tutari periyotsuz gosterilir: "23 TL" */
  public getDiscountAmountText() {
    const summary = this.getCalculateSummary();
    if (!summary || !angular.isNumber(summary.discountAmount)) {
      return '';
    }

    return (
      this.formatAmount(summary.discountAmount) + ' ' + this.getPriceUnit()
    );
  }

  /** "2. aydan itibaren" */
  public getFromMonthLabel() {
    const summary = this.getCalculateSummary();
    if (!summary) {
      return '';
    }

    return this.$translate.instant('packetCard.promocode.fromMonthX', {
      month: this.getFreeMonthCount() + 1
    });
  }

  public getCalculateDiscountedPriceText() {
    const summary = this.getCalculateSummary();
    if (!summary || !angular.isNumber(summary.discountedPrice)) {
      return '';
    }

    return this.formatPriceWithPeriod(summary.discountedPrice);
  }

  public getCalculateInfoText() {
    const summary = this.getCalculateSummary();
    if (!summary || !angular.isNumber(summary.discountAmount)) {
      return '';
    }

    const freeMonthCount = this.getFreeMonthCount();
    const params = {
      afterMonth: freeMonthCount,
      discountAmount: this.formatAmount(summary.discountAmount),
      monthCount: summary.discountMonthCount,
      priceUnit: this.getPriceUnit()
    };

    // Promokod trial aylarin tamamini kapsamiyorsa ay sayisi bedava ay sayaci
    // uzerinden yazilir; o sayac ezme durumunda trialCount degerini tasir.
    if (summary.trialOverridesFreeCount) {
      return this.$translate.instant('packetCard.promocode.calculateInfoTrialOverride', {
        discountAmount: this.formatAmount(summary.discountAmount),
        monthCount: freeMonthCount,
        priceUnit: this.getPriceUnit()
      });
    }

    return freeMonthCount === 1
      ? this.$translate.instant(
          'packetCard.promocode.calculateInfoFirst',
          params
        )
      : this.$translate.instant(
          'packetCard.promocode.calculateInfoAfterX',
          params
        );
  }

  /**
   * Bedava donemi olmayan kampanyanin yesil bilgi kutusu.
   * Indirimli donem sayisi dogrudan discountedPrices uzunlugudur; kampanya bitiminden
   * sonraki donemlerde zaten standart fiyat gecerli oldugu icin o cumle yazilmaz.
   */
  public getDiscountFromFirstMonthInfoText() {
    const summary = this.getCalculateSummary();
    if (!summary || !angular.isNumber(summary.discountAmount)) {
      return '';
    }

    const translationKey = this.isYearlyPackage()
      ? 'packetCard.promocode.calculateInfoNoTrialYearly'
      : 'packetCard.promocode.calculateInfoNoTrial';

    return this.$translate.instant(translationKey, {
      discountAmount: this.getDiscountAmountText(),
      periodCount: summary.totalCount
    });
  }

  private getPriceUnit() {
    return this.priceDetails && this.priceDetails.priceUnit
      ? this.priceDetails.priceUnit
      : 'TL';
  }

  private getCalculatedDiscountRateValue() {
    if (!this.discount) {
      return '';
    }

    if (angular.isNumber(this.discount.computedDiscountRate)) {
      return this.discount.computedDiscountRate.toString();
    }

    return this.discount.discountRate;
  }

  private formatPriceWithPeriod(price: number) {
    const priceUnit = this.getPriceUnit();
    const period =
      this.priceDetails && this.priceDetails.time ? this.priceDetails.time : '';
    return this.formatPrice(price) + ' ' + priceUnit + period;
  }

  /** Her zaman iki basamak: "114,99" (tr) / "114.99" (en). */
  private formatPrice(price: number) {
    const fixed = price.toFixed(2);

    return this.i18n.getCurrentLanguage() === 'en'
      ? fixed
      : fixed.replace('.', ',');
  }

  /** Paket fiyati servisten string de gelebiliyor. Sayiya cevrilemezse undefined. */
  private toNumber(value: any): number {
    const parsed = angular.isNumber(value)
      ? value
      : parseFloat(String(value).replace(',', '.'));

    return isNaN(parsed) ? undefined : parsed;
  }

  /** Indirim tutari tam sayiysa kurusu gosterilmez: "23 TL", "22,50 TL". */
  private formatAmount(amount: number) {
    const rounded = Math.round(amount * 100) / 100;

    return rounded % 1 === 0 ? rounded.toString() : this.formatPrice(rounded);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/packet-card/packet-card.controller.ts